import Nav from '../components/Nav'
import Footer from '../components/Footer'
import Products from '../components/Products'

export default function Product() {
  function display() {
    document.getElementById("box_1").style.display = "block";
    document.getElementById("box_2").style.display = "none";
    document.getElementById("box_3").style.display = "none";
  }
  function display2() {
    document.getElementById("box_2").style.display = "block";
    document.getElementById("box_1").style.display = "none";
    document.getElementById("box_3").style.display = "none";
  }
  function display3() {
    document.getElementById("box_3").style.display = "block";
    document.getElementById("box_1").style.display = "none";
    document.getElementById("box_2").style.display = "none";
  }

  return (
    <div>
      <Nav />
      <div>
        <h1>Products</h1>
        <Products limit="100" />
        <div id="serviceDiv">
          <section id="left-section">
            {/* <!-- slideshow --> */}
            
            <div className="containerSlideshow">
              <div className="mySlides">
                <div className="numbertext"></div>
                <img
                  src="https://marketpresso.com/public/upload/96/lib/62376_1580214983_lib.jpg"
                  alt=""
                  style={{ width: 100 + '%' }}
                />
              </div>

              <div classNameName="mySlides">
                <div classNameName="numbertext"></div>
                <img
                  src="https://marketpresso.com/public/upload/96/lib/80614_1580214967_lib.jpg"
                  alt=""
                  style={{ width: 100 + '%' }}
                />
              </div>

              <div className="mySlides">
                <div className="numbertext"></div>
                <img
                  src="https://marketpresso.com/public/upload/96/lib/50194_1580214952_lib.jpg"
                  alt=""
                  style={{ width: 100 + '%' }}
                />
              </div>

              <div className="mySlides">
                <div className="numbertext"></div>
                <img
                  src="https://marketpresso.com/public/upload/96/lib/64811_1580215072_lib.jpg"
                  alt=""
                  style={{ width: 100 + '%' }}
                />
              </div>

              <span className="prev" onClick="plusSlides(-1)">❮</span>
              <span className="next" onClick="plusSlides(1)">❯</span>

              <div className="caption-container">
                <p id="caption"></p>
              </div>

              <div className="row-slideshow">
                <div className="column-slideshow">
                  <img
                    className="demo cursor"
                    src="https://marketpresso.com/public/upload/96/lib/62376_1580214983_lib.jpg"
                    alt=""
                    style={{ width: 80 + '%' }}
                    onclick="currentSlide(1)"
                    id="demo"
                  />
                </div>

                <div className="column-slideshow">
                  <img
                    className="demo cursor"
                    src="https://marketpresso.com/public/upload/96/lib/80614_1580214967_lib.jpg"
                    alt=""
                    style={{ width: 80 + '%' }}
                    onclick="currentSlide(2)"
                  />
                </div>

                <div className="column-slideshow">
                  <img
                    className="demo cursor"
                    src="https://marketpresso.com/public/upload/96/lib/50194_1580214952_lib.jpg"
                    alt=""
                    style={{ width: 80 + '%' }}
                    onclick="currentSlide(3)"
                  />
                </div>

                <div className="column-slideshow">
                  <img
                    className="demo cursor"
                    src="https://marketpresso.com/public/upload/96/lib/64811_1580215072_lib.jpg"
                    alt=""
                    style={{ width: 80 + '%' }}
                    onclick="currentSlide(4)"
                  />
                </div>
              </div>
            </div>
            
            {/* about */}
            <br />
            <div className="about_service abt-txt mgt24">
              <div className="m_bot2">
                <h2>About This Service</h2>
                <br />
              </div>
              <div>
                Business Card is not just any card; it is your first impression,
                business philosophy and a brief account of the wonders that you can
                do! In short, it represents you!<br /><br />
              </div>

              <div>
                That is where I come into play! Hi, I am NAME. An experienced
                graphic designer using Adobe Photoshop, Illustrator &amp; Corel
                Draw. I enjoy creating unique &amp; professional quality designs for
                Business Cards, Letterheads &amp; Envelopes. I’ll create the designs
                based on your needs to make it a perfect identity for your business.
                You must love it!
              </div>
              <div><br /></div>
              <div>
                <b>Why Me?<br /><br /></b>
              </div>
              <div>• Professional &amp; Quality Design</div>
              <div>• High-Resolution Guaranteed</div>
              <div>• Quick Response</div>
              <div>• Quick Revisions until you satisfied</div>
              <div>• Friendly Communication</div>
              <div>• Free Minor changes anytime</div>
              <div><br /></div>
            </div>
          </section>

          {/* // <!-- aside content --> */}
          <aside id="right-section">
            <div className="pkg-box">
              <ul className="pkg-ul">
                <li className="pkg-list">
                  <span onClick={display} >Basic Package</span>
                </li>
                <li className="pkg-list">
                  <span onClick={display2} >Standard Package</span>
                </li>
                <li className="pkg-list">
                  <span onClick={display3} >Premium Package</span>
                </li>
              </ul>
              <div className="tab-content">
                <div
                  id="box_1"
                  className="container tab-pane show"
                  style={{ display: 'block' }}
                >
                  <br />
                  <input type="hidden" id="external_link_123" value="" />
                  <div>
                    <div className="row">
                      <div className="pre-sty mxpd0">
                        <p className="pkg-para">
                          1 Layout + 1 person details + 300 dpi Print Ready JPG/PDF
                          files
                        </p>
                        <p></p>
                      </div>
                      <div className="pre-sty txt-right padl0 mxpd0">
                        <p id="vamt_123" className="theme_color_txt vamt_123">$15</p>
                      </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="pre-sty m_top2 m_bot2">

                      <p>
                        <i
                          className="far fa-clock theme_color_txt"
                          aria-hidden="true"
                        ></i>
                        &nbsp;3 Days Delivery &nbsp; &nbsp;
                      </p>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="pre-sty m_bot2">
                      <p className="pkg-para">What's Included</p>

                      <ul className="pac-lst">
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Concept - 1
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Print-Ready
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Double-Sided
                        </li>
                      </ul>
                    </div>

                    <div className="m_top2 m_bot2 cmp-pack">
                      <a className="con-btn btn" href="/" onclick="">
                        Proceed <span className="vamt_123">$15</span></a
                      >

                      <div className="divcontact-seller">
                        <a className="theme_color_txt" onclick="" href="/"
                        >Contact Seller</a
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="box_2"
                  className="container tab-pane show active"
                  style={{ display: 'none' }}
                >
                  <br />
                  <input type="hidden" id="external_link_124" value="" />
                  <div className="">
                    <div className="row">
                      <div className="pre-sty mxpd0">
                        <p className="pkg-para">
                          2 Layouts + Up to 2 persons details + 500 dpi Print Ready
                          JPG/PDF files
                        </p>
                        <p></p>
                      </div>
                      <div className="pre-sty txt-right padl0 mxpd0">
                        <p id="vamt_124" className="theme_color_txt vamt_124">$25</p>
                      </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="pre-sty m_top2 m_bot2">

                      <p>
                        <i
                          className="far fa-clock theme_color_txt"
                          aria-hidden="true"
                        ></i>
                        &nbsp;5 Days Delivery &nbsp; &nbsp;
                      </p>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="pre-sty m_bot2">
                      <p className="pkg-para">What's Included</p>

                      <ul className="pac-lst">
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Concept - 2
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Print-Ready
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;&nbsp;Double-Sided
                        </li>
                      </ul>
                    </div>

                    <div className="m_top2 m_bot2 cmp-pack">
                      <a className="con-btn btn" href="/" onclick="">
                        Proceed <span className="vamt_124">$25</span></a
                      >

                      <div className="divcontact-seller">
                        <a className="theme_color_txt" onclick="" href="/"
                        >Contact Seller</a
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="box_3"
                  className="container tab-pane show"
                  style={{ display: 'none' }}
                >
                  <br />
                  <input type="hidden" id="external_link_125" value="" />
                  <div className="">
                    <div className="row">
                      <div className="pre-sty mxpd0" alt=""
                        style={{ width: 90 + '%' }}>
                        <p className="pkg-para">
                          2 Layouts + Up to 3 persons details + Superior Quality
                          1200dpi PDF/PSD files + QR Code Quick Revisions
                        </p>
                      </div>
                      <div className="pre-sty txt-right padl0 mxpd0">
                        <p id="vamt_125" className="theme_color_txt vamt_125">$50</p>
                      </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="pre-sty m_top2 m_bot2">

                      <p>
                        <i
                          className="far fa-clock theme_color_txt"
                          aria-hidden="true"
                        ></i>
                        &nbsp;7 Days Delivery &nbsp; &nbsp;
                      </p>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="pre-sty m_bot2">
                      <p className="pkg-para">What's Included</p>

                      <ul className="pac-lst">
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Concept - 2
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Print-Ready
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          &nbsp;Double-Sided
                        </li>
                        <li>
                          <i
                            className="fa fa-check tick-col theme_color_txt"
                            aria-hidden="true"
                          ></i>
                          Source File
                        </li>
                      </ul>
                    </div>

                    <div className="m_top2 m_bot2 cmp-pack">
                      <a className="con-btn btn" href="/" onclick="">
                        Proceed <span className="vamt_125">$50</span></a
                      >

                      <div className="divcontact-seller">
                        <a className="theme_color_txt" onclick="" href="/"
                        >Contact Seller</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- package table --> */}
            <div className="table-striped1">
              <h1 className="pkg-h1">Compare Package</h1>
              <table className="table table-striped" cellspacing="0">
                <tbody>
                  <tr>
                    <th>Package</th>

                    <th>
                      Basic Package <br />
                      $200
                    </th>

                    <th>
                      Standard Package <br />
                      $500
                    </th>

                    <th>
                      Premium Package <br />
                      $800
                    </th>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">Page</td>

                    <td className="text-center fs-12">
                      1
                    </td>

                    <td className="text-center fs-12">
                      5
                    </td>

                    <td className="text-center fs-12">
                      10
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">Design Customization</td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">Content Upload</td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">Responsive Design</td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">Plugins/Extensions</td>

                    <td className="text-center fs-12">
                      5
                    </td>

                    <td className="text-center fs-12">
                      8
                    </td>

                    <td className="text-center fs-12">
                      12
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">E-Commerce Functionality</td>

                    <td className="text-center">
                      <i
                        className="fa fa-times tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-times tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fs-12">15 Poducts</td>

                    <td className="text-center">
                      <i
                        className="fa fa-times tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-times tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>

                    <td className="text-center">
                      <i
                        className="fa fa-check tick-col theme_color_txt"
                        aria-hidden="true"
                      ></i>
                    </td>
                  </tr>

                  <tr>
                    <td className="txt-left fw-500">
                      Total
                    </td>

                    <td className="fw-500 text-center">
                      $200 <br /><button
                        onclick=""
                        type="button"
                        className="btn sel-btn vamt_129"
                      >
                        Select
                      </button>
                    </td>
                    <td className="fw-500 text-center">
                      $500 <br /><button
                        onclick=""
                        type="button"
                        className="btn sel-btn vamt_130"
                      >
                        Select
                      </button>
                    </td>
                    <td className="fw-500 text-center">
                      $800 <br /><button
                        onclick=""
                        type="button"
                        className="btn sel-btn vamt_131"
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </aside>
        </div>
        <section className="main-container">
          <h2 className="review-h2">Customer Reviews</h2>
          <div className="container1">
            <div className="container-img">
              <img src="" alt="" />
            </div>
            <div className="container-name">
              <h2>Ishan Goyal</h2>
              <div id="stars">
                <span className="fa fa-star checked"></span>
                <span className="fa fa-star checked"></span>
                <span className="fa fa-star checked"></span>
                <span className="fa fa-star checked"></span>
                <span className="fa fa-star checked"></span>
              </div>

              <p>
                Thank you for this pretty design. I went over my revision limit (2)
                and he still gave me my final request. It was truly amazing working
                with this seller. Thank you!
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

